import { render, staticRenderFns } from "./investment.vue?vue&type=template&id=7670dcdc"
import script from "./investment.vue?vue&type=script&lang=js"
export * from "./investment.vue?vue&type=script&lang=js"
import style0 from "./investment.vue?vue&type=style&index=0&id=7670dcdc&prod&lang=scss"
import style1 from "../../../assets/styles/v2/common.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "../main.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports